import React from 'react'

import { useMissingPhotosInSaleQuery } from '@edge/spark/io-dashboards'
import { CardType } from '@edge/spark/io-dashboards'
import { CircularProgressWidget } from '../../BaseComponents/CircularProgressWidget'
import type { BasicWidgetProps } from '../../types'

const SEARCH_STRING = 'status:available'
const MINIMUM_PHOTOS = 5

const NeedPhotos: React.FC<BasicWidgetProps> = ({
    config: { text = 'Need Photos' },
    widgetId,
    handleConfig,
    readonly,
}: BasicWidgetProps) => {
    const { loading, data } = useMissingPhotosInSaleQuery({
        variables: {
            searchString: SEARCH_STRING,
            searchStringPhotos: `${SEARCH_STRING} photos<${MINIMUM_PHOTOS}`,
        },
    })

    const units = data?.auction?.consigned?.vehicleCount || 0
    const needsPhotos = data?.auction?.photos?.vehicleCount || 0

    return (
        <CircularProgressWidget
            cardType={CardType.VEHICLE}
            action={{
                text: 'View Vehicles',
                link: `/vehicles-without-photos`,
            }}
            loading={loading}
            count={needsPhotos}
            total={units}
            text={text}
            widgetId={widgetId}
            handleConfig={handleConfig}
            readonly={readonly}
        />
    )
}

export default NeedPhotos
